export default __webpack_public_path__ + "static/media/typechart.54d9c3a1.jpg";